

export const FETCH_MAIL_REQUEST = 'FETCH_MAIL_REQUEST';
export const FETCH_MAIL_REQUEST_COMPLETED = 'FETCH_MAIL_REQUEST_COMPLETED';
export const FETCH_MAIL_REQUEST_ERROR = 'FETCH_MAIL_REQUEST_ERROR';
export const FETCH_MAIL_RESET = 'FETCH_MAIL_RESET';

export const FETCH_MAIL_LIST_REQUEST = 'FETCH_MAIL_LIST_REQUEST';
export const FETCH_MAIL_LIST_REQUEST_COMPLETED = 'FETCH_MAIL_LIST_REQUEST_COMPLETED';
export const FETCH_MAIL_LIST_REQUEST_ERROR = 'FETCH_MAIL_LIST_REQUEST_ERROR';

export const ADD_MAIL_RESET = 'ADD_MAIL_RESET';
export const ADD_MAIL_REQUEST = 'ADD_MAIL_REQUEST';
export const ADD_MAIL_REQUEST_COMPLETED = 'ADD_MAIL_REQUEST_COMPLETED';
export const ADD_MAIL_REQUEST_ERROR = 'ADD_MAIL_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/maildetails.js